import * as actionTypes from '../constants/rolesActionTypes';

const initialState = {
  rolesList: null,
  isStarted: false,
  isLoad: false,
  isError: false,
  msg: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_ROLES_START:
      return {
        ...state,
        isStarted: true,
        isLoad: false,
        isError: false,
        msg: null,
      };
    case actionTypes.FETCH_ROLES_SUCCESS:
      return {
        ...state,
        isStarted: false,
        isLoad: true,
        rolesList: action.payload,
      };
    case actionTypes.FETCH_ROLES_FAILURE:
      return {
        ...state,
        isStarted: false,
        isLoad: true,
        isError: true,
        rolesList: null,
        msg: action.payload,
      };
    case actionTypes.ROLES_CLEAR_STORE:
      return initialState;
    default:
      return state;
  }
}
